import React from 'react';
import {
    BannerContainer,
    BannerMainWrapper,
    BannerImageWrapper,
    BannerContentWrapper,
    BannerText,
    BannerSubText,
    BannerButtonWrapper,
    Container,
} from './more-questions-banner.styles';
import CTAButton from '../../../../components/cta-button/cta-button';
import AloneWaving from '../../../../assets/images/alone_waving.webp';
import TogetherWaving from '../../../../assets/images/together_waving.webp';
import useIsMobile from '../../../../hooks/useIsMobile';
import useContactUsModalStore from '../../../../stores/contactUsModalStore';
import { useTranslation } from 'react-i18next';

const MoreQuestionsBanner: React.FC = () => {
    const isMobile = useIsMobile();
    const { t } = useTranslation();

    // Stores
    const setIsContactUsModalVisible = useContactUsModalStore(state => state.setIsVisible);

    const onClickContactUs = () => {
        setIsContactUsModalVisible(true);
    }

    return (
        <Container>
            <BannerContainer>
                <BannerMainWrapper>
                    <BannerImageWrapper>
                        <img src={isMobile ? AloneWaving : TogetherWaving} alt="Waving" />
                    </BannerImageWrapper>
                    <BannerContentWrapper>
                        <BannerText>{t("pages.knowledge_hub.more_questions_banner.title")}</BannerText>
                        <BannerSubText>{t("pages.knowledge_hub.more_questions_banner.subtitle")}</BannerSubText>
                    </BannerContentWrapper>
                </BannerMainWrapper>

                {/* Desktop Button */}
                <BannerButtonWrapper className="d-none d-md-inline">
                    <CTAButton
                        variant="primary"
                        size="L"
                        label={t("buttons.contact_us")}
                        onClick={onClickContactUs}
                    />
                </BannerButtonWrapper>

                {/* Mobile Button */}
                <CTAButton
                    className="d-md-none mt-2"
                    variant="primary"
                    size="S"
                    label={t("buttons.contact_us")}
                    onClick={onClickContactUs}
                    fullWidth
                />
            </BannerContainer>
        </Container>
    );
};

export default MoreQuestionsBanner;
